import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const surfacesPlugin = createPlugin({
  id: 'surfaces',
  routes: {
    ...Routes,
  },
  externalRoutes: {},
});

export const ConfidenceSurfacesPage = surfacesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceSurfacesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-surfaces", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
